// extracted by mini-css-extract-plugin
export default {"conatiner":"Invoice_conatiner__woltW","status":"Invoice_status__4V5UL"};